import React from "react"
import { Col, Label } from "reactstrap"
import UploadedFileBox from "pages/KYC/uploadedFileBox"
import KycDocumentUpload from "pages/KYC/kycDocumentUpload"

const errorMessage = "Please upload file in PDF format only."

const RenderBusinessType = ({ type, validation, kycData, preview = false }) => {
  switch (type) {
    case "Private Limited Company":
    case "Public Limited Company":
    case "One Person Company":
      return (
        <CompanyComponent
          validation={validation}
          kycData={kycData}
          preview={preview}
        />
      )
    case "Limited Liability Partnership":
      return <LLP validation={validation} kycData={kycData} preview={preview} />
    case "Sole Proprietorship":
    case "Partnership Firm":
      return (
        <Partnership
          validation={validation}
          kycData={kycData}
          preview={preview}
        />
      )
    case "Hindu Undivided Family":
      return <HUF validation={validation} kycData={kycData} preview={preview} />
    case "Co-operative Society":
    case "Trust/Association of Persons":
      return (
        <SocietyAndTrust
          validation={validation}
          kycData={kycData}
          preview={preview}
        />
      )
    default:
      return null // or some fallback UI
  }
}

export default RenderBusinessType

function CompanyComponent({ validation, kycData, preview }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Memorandum of Association <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"memorandum_of_association"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />

        {/* {kycData?.businessAdditionalDetails?.memorandum_of_association && (
          <UploadedFileBox
            label={"Memorandum of Association"}
            href={
              kycData?.businessAdditionalDetails?.memorandum_of_association_url
            }
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Articles of Association <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"articles_of_association"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.articles_of_association && (
          <UploadedFileBox
            label={"Articles of Association"}
            href={
              kycData?.businessAdditionalDetails?.articles_of_association_url
            }
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Certifcate of Incorporation <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.certificate_of_incorporation && (
          <UploadedFileBox
            label={"Certifcate of Incorporation"}
            href={
              kycData?.businessAdditionalDetails
                ?.certificate_of_incorporation_url
            }
          />
        )} */}
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
          />
          {/* {kycData?.businessAdditionalDetails?.gstin_certificate && (
            <UploadedFileBox
              label={"GSTIN Certificate"}
              href={kycData?.businessAdditionalDetails?.gstin_certificate_url}
            />
          )} */}
        </Col>
      )}
    </>
  )
}

function LLP({ validation, kycData, preview }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Initial LLP Agreement <span className="error">*</span>
        </Label>
        <KycDocumentUpload
          fieldKey={"initial_llp_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.initial_llp_deed && (
          <UploadedFileBox
            label={"Initial LLP Agreement"}
            href={kycData?.businessAdditionalDetails?.initial_llp_deed_url}
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Supplemental LLP Agreement</Label>
        <KycDocumentUpload
          fieldKey={"latest_llp_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.latest_llp_deed && (
          <UploadedFileBox
            label={"Supplemental LLP Agreement"}
            href={kycData?.businessAdditionalDetails?.latest_llp_deed_url}
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Certificate of Incorporation</Label>
        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.certificate_of_incorporation && (
          <UploadedFileBox
            label={"Certificate of Incorporation"}
            href={
              kycData?.businessAdditionalDetails
                ?.certificate_of_incorporation_url
            }
          />
        )} */}
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
          />
          {/* {kycData?.businessAdditionalDetails?.gstin_certificate && (
            <UploadedFileBox
              label={"GSTIN Certificate"}
              href={kycData?.businessAdditionalDetails?.gstin_certificate_url}
            />
          )} */}
        </Col>
      )}
    </>
  )
}

function Partnership({ validation, preview }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">Registration Certificate</Label>
        <KycDocumentUpload
          fieldKey={"registration_certificate"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Partnership Deed <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"initial_partnership_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.initial_partnership_deed && (
          <UploadedFileBox
            label={"Partnership Deed"}
            href={
              kycData?.businessAdditionalDetails?.initial_partnership_deed_url
            }
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Supplemental Partnership Deed</Label>
        <KycDocumentUpload
          fieldKey={"latest_partnership_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.latest_partnership_deed && (
          <UploadedFileBox
            label={"Supplemental Partnership Deed"}
            href={
              kycData?.businessAdditionalDetails?.latest_partnership_deed_url
            }
          />
        )} */}
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Certificate of Incorporation</Label>
        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.certificate_of_incorporation && (
          <UploadedFileBox
            label={"Certificate of Incorporation"}
            href={
              kycData?.businessAdditionalDetails
                ?.certificate_of_incorporation_url
            }
          />
        )} */}
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
          />
          {/* {kycData?.businessAdditionalDetails?.gstin_certificate && (
            <UploadedFileBox
              label={"GSTIN Certificate"}
              href={kycData?.businessAdditionalDetails?.gstin_certificate_url}
            />
          )} */}
        </Col>
      )}
    </>
  )
}

function HUF({ validation, preview }) {
  return (
    <>
      {/* <Col xl={12}>
        <Label className="col-form-label">
          HUF Creation Document <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"huf_creation_document"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
      </Col> */}
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
          />
          {/* {kycData?.businessAdditionalDetails?.gstin_certificate && (
            <UploadedFileBox
              label={"GSTIN Certificate"}
              href={kycData?.businessAdditionalDetails?.gstin_certificate_url}
            />
          )} */}
        </Col>
      )}
    </>
  )
}
function SocietyAndTrust({ validation, preview }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Trust Deed <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"trust_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.trust_deed && (
          <UploadedFileBox
            label={"Trust Deed"}
            href={kycData?.businessAdditionalDetails?.trust_deed_url}
          />
        )} */}
      </Col>

      <Col xl={12}>
        <Label className="col-form-label">
          Society Bye-Laws <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"society_bye_laws"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
        />
        {/* {kycData?.businessAdditionalDetails?.society_bye_laws && (
          <UploadedFileBox
            label={"Society Bye-Laws"}
            href={kycData?.businessAdditionalDetails?.society_bye_laws_url}
          />
        )} */}
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>

          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
          />
          {/* {kycData?.businessAdditionalDetails?.gstin_certificate && (
            <UploadedFileBox
              label={"GSTIN Certificate"}
              href={kycData?.businessAdditionalDetails?.gstin_certificate_url}
            />
          )} */}
        </Col>
      )}
    </>
  )
}
